import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { _T, C } from '../shared/theme';
import { s_PB, s_GB } from '../shared/styles';
import { notifyUser, deleteNotification } from '../shared/dbService';

const BASE = process.env.REACT_APP_API_URL || '/api';

export default function GroupInvitePopup({ notifications, currentUserId, userName, lang, setNotifications }) {
  const nl = lang === 'nl';
  const [loading, setLoading] = useState(false);

  // Show the first unread group_invite that has full meta
  const invite = notifications.find(n => n.type === 'group_invite' && n.meta?.groupId && !n.read);
  if (!invite) return null;

  const meta = invite.meta;

  const dismissAsRead = () => {
    setNotifications(prev => prev.map(n => n.id === invite.id ? { ...n, read: true } : n));
  };

  const handleAccept = async () => {
    setLoading(true);
    await fetch(`${BASE}/groups/${meta.groupId}/members/${currentUserId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ uid: currentUserId, status: 'accepted' }),
    });
    if (meta.inviterUserId) {
      notifyUser(meta.inviterUserId, 'group_invite_accepted', userName,
        nl
          ? `${userName} heeft je uitnodiging voor ${meta.groupName} geaccepteerd`
          : `${userName} accepted your invitation to ${meta.groupName}`
      );
    }
    deleteNotification(invite.id);
    setNotifications(prev => prev.filter(n => n.id !== invite.id));
    setLoading(false);
  };

  const handleDecline = async () => {
    setLoading(true);
    await fetch(`${BASE}/groups/${meta.groupId}/members/${currentUserId}`, { method: 'DELETE' });
    if (meta.inviterUserId) {
      notifyUser(meta.inviterUserId, 'group_invite_declined', userName,
        nl
          ? `${userName} heeft je uitnodiging voor ${meta.groupName} geweigerd`
          : `${userName} declined your invitation to ${meta.groupName}`
      );
    }
    deleteNotification(invite.id);
    setNotifications(prev => prev.filter(n => n.id !== invite.id));
    setLoading(false);
  };

  const groupColor = meta.groupColor || '#7B6FD0';

  return ReactDOM.createPortal(
    <div style={{ position: 'fixed', inset: 0, zIndex: 8000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}
      onClick={dismissAsRead}>
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(5,8,18,0.80)', backdropFilter: 'blur(8px)' }} />
      <div onClick={e => e.stopPropagation()} style={{
        position: 'relative', width: '100%', maxWidth: 360,
        background: _T.bg2, borderRadius: 22,
        border: `1px solid ${_T.cardBorderTop}`,
        padding: '28px 24px 24px',
        boxShadow: '0 24px 64px rgba(0,0,0,0.7)',
      }}>
        {/* Close */}
        <button onClick={dismissAsRead} style={{ position: 'absolute', top: 14, right: 14, background: 'none', border: 'none', color: C.silver, cursor: 'pointer', fontSize: 20, lineHeight: 1 }}>×</button>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 22 }}>
          <div style={{ width: 64, height: 64, borderRadius: 18, background: `${groupColor}18`, border: `2px solid ${groupColor}55`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 30, margin: '0 auto 14px' }}>
            {meta.groupIcon || '🧩'}
          </div>
          <div style={{ fontSize: 10, color: groupColor, letterSpacing: 3, fontWeight: 700, marginBottom: 6 }}>
            {nl ? 'GROEPSUITNODIGING' : 'GROUP INVITATION'}
          </div>
          <div style={{ color: C.white, fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
            {meta.groupName}
          </div>
          <div style={{ color: C.silver, fontSize: 13, lineHeight: 1.5 }}>
            <span style={{ color: _T.accent, fontWeight: 600 }}>{invite.from}</span>
            {nl ? ' nodigt je uit om lid te worden van deze groep.' : ' invites you to join this group.'}
          </div>
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={handleAccept} disabled={loading}
            style={s_PB({ flex: 1, opacity: loading ? 0.6 : 1, fontSize: 14 })}>
            ✓ {nl ? 'Accepteren' : 'Accept'}
          </button>
          <button onClick={handleDecline} disabled={loading}
            style={s_GB({ flex: 1, opacity: loading ? 0.6 : 1, fontSize: 14 })}>
            ✕ {nl ? 'Weigeren' : 'Decline'}
          </button>
        </div>

        {/* Later hint */}
        <div style={{ textAlign: 'center', marginTop: 12, color: `${C.silver}88`, fontSize: 11 }}>
          {nl ? 'Tik buiten dit venster om later te beslissen' : 'Tap outside to decide later'}
        </div>
      </div>
    </div>,
    document.body
  );
}
